import React from "react";

type Props = {};

const SkeletonSpacer = (props: Props) => {
  return <div className="w-full skeleton__grey skeleton-small"></div>;
};

export default SkeletonSpacer;
